module.exports = __webpack_public_path__ + "static/media/mob20.378bd0ec.jpg";